import api from 'ApiConfig';

const assignmentAttachmentServices = {
  uploadAttachment: (formData) =>
    api.post('/assignment-attachment/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  batchUpload: (formData) =>
    api.post('/assignment-attachment/batch-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  getAttachmentsByAssignment: (assignmentId) =>
    api.get(`/assignment-attachment/${assignmentId}`),

  deleteAttachment: (id) =>
    api.delete(`/assignment-attachment/${id}`),
};

export default assignmentAttachmentServices;
